<script setup lang="ts">
defineProps<{
  labelIcon?: string;
  noBody?: boolean;
}>();
const store = useSongStore();
</script>

<template>
  <Container
    v-if="!store.loading"
    class="router-content"
  >
    <Card :no-body="noBody">
      <slot />
    </Card>
  </Container>
</template>

<style scoped lang="postcss"></style>
